import React from 'react'
import { classNameBuilder } from '@/helpers'

export interface FormProps {
  onSubmit: () => void
  children: React.ReactNode
  className?: string
}

export function Form({ children, onSubmit, className = '' }: FormProps) {
  return (
    <form
      noValidate
      className={classNameBuilder('flex flex-col', className)}
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onSubmit()
      }}
    >
      {children}
    </form>
  )
}

export default Form
